export enum UiInputQueryType {
    value = 'value',
    columnGroupKey = 'columnGroupKey',
}

export type UiInputQuery = ColumnGroupKeyUiInputQuery | ValueUiInputQuery;

export interface UiInputQueryBase {
    key: string;
    value?: any;
    type: UiInputQueryType;
}

export type ValueUiInputQuery = UiInputQueryBase & {
    type: UiInputQueryType.value;
};

export type ColumnGroupKeyUiInputQuery = UiInputQueryBase & {
    type: UiInputQueryType.columnGroupKey;
    options: {
        columnKey: string;
    };
};



// WEBPACK FOOTER //
// ./src/models/configuration/explorer/UiInputQuery.ts